
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { useSelector  } from 'react-redux';

import {
    IfComp,
    PanelTitle
} from '../../core';

import { getDataProjectId } from '../../project';

import { getInfo } from '../reducers'

import {
    INFO_TYPE_HOME,
    INFO_TYPE_NO,
    INFO_TYPE_OBJECT,
    INFO_TYPE_OBJECT_CREATE,
    INFO_TYPE_OBJECT_EDIT,
    INFO_TYPE_OBJECT_LIST
} from '../reducers/infoPanelType';

import {
    getMessage,
    getType
} from '../reducers/info'

import useDataModelDefinition from '../hooks/useDataModelDefinition';

import InfoHome from './InfoHome';
import ObjectInfoNo from './ObjectInfoNo';
import ObjectCreatePanel from './objectCreate/ObjectCreatePanel';
import ObjectDetailPanel from './objectDetail/ObjectDetailPanel';
import ObjectEditPanel from './objectEdit/ObjectEditPanel';
import ObjectListPanel from './ObjectListPanel';

const DataPanel = ({appActions, appConfig}) => {

    const classNames = mergeStyleSets({
        DataPanel: {
            padding: 4
        },
        titleContainer: {
        },
        message: {
            fontSize: 12
        },
        content: {
        }
    });

    const dataProjectId = useSelector(state => getDataProjectId(state.project));
    const dataModelDefinition = useDataModelDefinition(dataProjectId);
    const message = useSelector(state => getMessage(getInfo(state.data)));
    const type = useSelector(state => getType(getInfo(state.data)));

    return (
        <Stack verticalFill className={classNames.DataPanel} tokens={{childrenGap: 4}}>
            <Stack horizontal className={classNames.titleContainer}>
                <Stack.Item grow>
                    <PanelTitle title="DATOVÝ PANEL" />
                </Stack.Item>
                <IfComp cond={dataModelDefinition.dataModelDefinition}>
                    <Stack.Item>
                        <div className={classNames.message}>{message}</div>
                    </Stack.Item>
                </IfComp>
            </Stack>
            <IfComp cond={dataModelDefinition.dataModelDefinition}>
                <Stack.Item grow className={classNames.content}>
                    {(type === INFO_TYPE_HOME) && <InfoHome appActions={appActions} />}
                    {(type === INFO_TYPE_NO) && <ObjectInfoNo appActions={appActions} appConfig={appConfig} />}
                    {(type === INFO_TYPE_OBJECT) && <ObjectDetailPanel appActions={appActions} />}
                    {(type === INFO_TYPE_OBJECT_CREATE) && <ObjectCreatePanel appActions={appActions} />}
                    {(type === INFO_TYPE_OBJECT_EDIT) && <ObjectEditPanel appActions={appActions} />}
                    {(type === INFO_TYPE_OBJECT_LIST) && <ObjectListPanel />}
                </Stack.Item>
            </IfComp>
            <IfComp cond={!dataModelDefinition.dataModelDefinition}>
                <Stack.Item align="stretch">
                    <div>Nahrávám...</div>
                </Stack.Item>
            </IfComp>
        </Stack>
    );
}

export default DataPanel;
